import React from 'react';
import BarChart from '../../../components/BarChart/BarChart';
import { formatLocale } from 'd3';

const EurosVWS = () => {

  const localeFormatter = formatLocale({
    "decimal": ",",
    "thousands": ".",
  });

  const formatValueTooltip = val => localeFormatter.format(',.1f')(val) + ' miljard euro';
  const formatValueY = val => localeFormatter.format(',.1f')(val);
  
  const createTable = (data,className) => (
    <table className="tabel">
      <tbody>
        {data.map((row) => <tr key={row.key}><td>{row.key}</td><td>{formatValueY(row.value)}</td></tr>)}
      </tbody>
    </table>
  );

  const data = [
      { key: 'Zorgverzekeringswet', value: 51.0 },
      { key: 'Wet langdurige zorg', value: 25.1 },
      { key: 'Wmo*', value: 1.9 },
      { key: 'Overig**', value: 4.1 },
  ];


  return (
    <div className="vis-euros-vws">

      <BarChart
        data={data}
        margin={{ top: 30, right: 0, bottom: 10, left: 210 }}
        barHeight={30}
        domain={[0,47]}
        color={ {fill: '#333', stroke: '#fff'} }
        formatValueTooltip={formatValueTooltip}
        formatValueY={formatValueY}
        padding={0.2}
        ticks={0}
      />

      {createTable(data)}

      <div className="vis-total">
        <p>Totaal</p>
        <p className="groot">82,2</p>
        <p>miljard euro in 2020</p>
      </div>

      <div className="vis-credit">
        <p>Begrote uitgaven aan zorg voor 2020 in miljard euro volgens het Rijk.</p>
        <p>* De bijdragen van het Rijk aan gemeenten voor uitvoering van de Wet maatschappelijke ondersteuning en Jeugdwet zijn overgeheveld naar het Gemeentefonds en vallen niet meer onder 'zorg' op de Rijksbegroting.</p>
        <p>** Onder 'overig' vallen ook de Wet publieke gezondheid en zorgbreed beleid.</p>
        <p>Bron: Rijksbegroting en miljoenennota 2020.</p>
      </div>

    </div>)
};

export default EurosVWS;

